import React from 'react';
import { Box, Paper, Button } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

/** Same-origin PDF from client public/ (avoids iframe blocked on wrong API port). */
const GUIDANCE_PDF_PUBLIC_URL = `${process.env.PUBLIC_URL || ''}/guidance/protocol-review-guidance.pdf`;

/** Slightly enlarged page; hide thumbnail sidebar. */
const pdfViewerSrc = (baseUrl) => `${baseUrl}#navpanes=0&toolbar=1&zoom=115`;

const WorkflowReviewGuidancePage = () => {
  const pdfUrl = GUIDANCE_PDF_PUBLIC_URL;
  const embedUrl = pdfViewerSrc(pdfUrl);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        height: 'calc(100vh - 88px)',
        overflow: 'hidden',
        boxSizing: 'border-box',
        px: { xs: 1, md: 2 },
        pt: 1,
        pb: 2,
      }}
    >
      <Box sx={{ mb: 1, flexShrink: 0 }}>
        <Button
          variant="contained"
          size="small"
          startIcon={<PictureAsPdfIcon />}
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open PDF
        </Button>
      </Box>

      <Paper
        variant="outlined"
        sx={{
          flex: 1,
          minHeight: 0,
          width: '100%',
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          boxSizing: 'border-box',
        }}
      >
        <Box
          component="iframe"
          title="Protocol review guidance PDF"
          src={embedUrl}
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'block',
            width: '100%',
            maxWidth: '100%',
            border: 'none',
          }}
        />
      </Paper>
    </Box>
  );
};

export default WorkflowReviewGuidancePage;
